import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import * as Ant from 'antd';
import * as AppActions from '../../AppActions';

const F = AppActions.F;

export default function TeamSpecialCommitteeList(props) {
  const {data} = props;

  if (!data) {
    return <Wrapper />;
  }

  return (
    <Wrapper>
      <div className="title">
        <h2>{F(data, 'title')}</h2>
      </div>
      <div className="container">
        <Ant.Descriptions bordered>
          {Array.isArray(data.groups) &&
            data.groups.length > 0 &&
            data.groups.map((it, index) => {
              return (
                <Ant.Descriptions.Item
                  label={<span className="group-label">{F(it, 'name')}</span>}
                  span={2}
                  children={
                    <div className="group-grid">
                      {it.list?.map((person, idx) => {
                        return <div className="item">{F(person, 'name')}</div>;
                      })}
                    </div>
                  }
                />
              );
            })}
        </Ant.Descriptions>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 40px;

  & > .title {
    margin-top: 10px;
    margin-bottom: 15px;
  }

  & > .container {
  }

  .group-label {
    display: block;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 0.95rem;
  }

  .group-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    & > .item {
      margin: 8px 0px;
      word-break: break-word;
      min-width: 100px;
      text-align: center;
      font-size: 0.95rem;
    }
  }
`;
